import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { User } from '../_types/user';
import { Observable } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { ParamsBuilder } from 'src/app/core/jsonapi/params/params-builder';
import { ResponseCollection } from 'src/app/core/jsonapi/responses/response-collection';

@Injectable({
  providedIn: 'root'
})
export class UsersService extends Service<User> {
  public override type = 'users';
  public override url = 'auth/users';


  public override DEBUG: boolean = true;
  public override CACHEABLE_METHODS: any = { all: true };

  public reassignCases(processorId: string): Observable<void> {
    let url = this.getAPIUrl() + "/" + processorId + '/reassignCases';
    return this.http.get<void>(url);
  }


  public recoverCases(processorId: string): Observable<void> {
    let url = this.getAPIUrl() + "/" + processorId + '/recoverCases';
    return this.http.get<void>(url);
  }
  public allListFiltered(params: IParamsCollection): Observable<ResponseCollection<User>>{
    let url = this.getAPIUrl() + '/allListFiltered';
    url += ParamsBuilder.paramsCollectionToQueryString(params);
    return this.http.get<ResponseCollection<User>>(url);
  }
}

